import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { PatientModel } from '../../models/consultation/patient.model';
import { PatientUrl } from '../../shared/urls/patient.url';
import { ConsultationStep, GroupConsultationStep, 
         ConsultationStepInfo, GroupConsultationStepInfo, GroupTemplateConsultationStepInfo } from '../../models/consultation/consultation.model';
import { ConsultationUrl } from '../../shared/urls/consultation.url';
import { Utility } from '../../common/utility';

@Injectable()
export class ConsultationProcessBarService {
    constructor(public baseService: BaseService) {
    }

    getPatientInfo(id) {
        const url = PatientUrl.GET_PATIENT_ACCOUNT.replace("{id}", id);
        return this.baseService.getData(url, null);
    }

    getRouterLinkConfig() {
        return ConsultationStepInfo;
    }

    getGroupInfo(id) {
        const url = ConsultationUrl.GET_GROUP_CONSULTATION.replace('{id}', id);
        return this.baseService.getData(url, null);
        //return {groupREF: 'GR001', groupName: 'GRoup 1'};
    }

    getGroupRouterLinkConfig() {
        return GroupConsultationStepInfo;
    }

    getGroupTemplateRouterLinkConfig() {
        return GroupTemplateConsultationStepInfo;
    }

    getConsultationNote(consultationId) {
        const url = ConsultationUrl.CONSULTATION_HISTORY_NOTE;
        return this.baseService.getData(url, { consultationId: consultationId});
    }

    updateConsultationNote(consultationId, param) {
        const url = Utility.stringFormat(ConsultationUrl.CONSULTATION_NOTE, [consultationId]);
        return this.baseService.postData(url, param);
    }
}

/* const stepInfo: Array<any> = [
    {
        step: ConsultationStep.PatientDetails,
        routerLink: '/consultation-process/patient-detail',
        name: 'Patient details'
    },
    {
        step: ConsultationStep.TripInformation,
        routerLink: '/consultation-process/trip-information',
        name: 'Trip information'
    },
    {
        step: ConsultationStep.MedicalConditions,
        routerLink: '/consultation-process/medical-conditions',
        name: 'Medical condition(s)'
    },
    {
        step: ConsultationStep.RecordPreviousVaccines,
        routerLink: '/consultation-process/record-previous-vaccines',
        name: 'Record previous vaccine(s)'
    },
    {
        step: ConsultationStep.SelectVaccination,
        routerLink: '/consultation-process/select-disease',
        name: 'Select disease(s)'
    },
    {
        step: ConsultationStep.PrescribeVaccination,
        routerLink: '/consultation-process/prescribe-vaccination',
        name: 'Prescribe vaccination(s)'
    },
    {
        step: ConsultationStep.SelectPrescriptions,
        routerLink: '/consultation-process/select-prescriptions',
        name: 'Select prescription(s)'
    },
    {
        step: ConsultationStep.LabTests,
        routerLink: '/consultation-process/lab-tests',
        name: 'Lab test(s)'
    },
    {
        step: ConsultationStep.SaveAndPrint,
        routerLink: '/consultation-process/save-consultation',
        name: 'Save'
    },
    {
        step: ConsultationStep.AdministerVaccination,
        routerLink: '/consultation-process/administer-vaccine',
        name: 'Administer Vaccination(s)'
    },
    {
        step: ConsultationStep.ConfirmLabTests,
        routerLink: '/consultation-process/confirmation-lab-tests',
        name: 'Confirm Lab Test(s)'
    },
    {
        step: 0,
        routerLink: 'consultation/waiting-room',
        name: ''
    }
]; 

const groupStepInfo: Array<any> = [
    {
        step: GroupConsultationStep.TripInformation,
        routerLink: '/consultation-process/trip-information',
        name: 'Trip information'
    },
    {
        step: GroupConsultationStep.RecommendedDiseases,
        routerLink: '/consultation-process/group-recommended-diseases',
        name: 'Recommended Disease(s)'
    },
    {
        step: GroupConsultationStep.RecommendedPrescriptions,
        routerLink: '/consultation-process/group-recommended-prescriptions',
        name: 'Recommended Prescription(s)'
    },
    {
        step: GroupConsultationStep.RecommendedLabTests,
        routerLink: '/consultation-process/group-recommended-lab-tests',
        name: 'Recommended Lab Test(s)'
    }
];
*/





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/consultation-progress-bar/consultation-process-bar.service.ts